import React, { useEffect, useState } from 'react'
import '../../styles/dashboard.css';
import useAxiosPrivate from '../../api/useAxiosPrivate';
import { useLocation } from 'react-router-dom';
import { notify } from '../toast';

const AdminUnpaidHolders = () => {

    const { state } = useLocation();


    const [holders, setHolders] = useState([]);
    const [totalHolders, setTotalHolders] = useState(1);

    const [pageLoading, setPageLoading] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    const fetchUnpaidHolders = async () => {
        try {

            if (totalHolders === holders.length) return notify('info', 'End of list reached')

            setPageLoading(true);

            const response = await axiosPrivate.get(`/admin/getUnpaidHolders?page=${Math.ceil(holders.length / 10) + 1}`);

            const data = response?.data
            setHolders(prev => [...prev, ...data?.holders]);
            setTotalHolders(data?.total)

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        if (holders.length === 0) fetchUnpaidHolders();

        // eslint-disable-next-line
    }, [holders]);

    const handleDelete = async (id) => {
        try {
            const result = await axiosPrivate.delete(`/admin/deleteUnpaidHolder/${id}`);
            notify('success', result?.data?.success)
            setHolders([]);
            fetchUnpaidHolders();

        } catch (err) {
            notify('failed', err?.response?.data?.message);
        }
    }

    return (
        <div className='container'>

            <h2 style={{ margin: '20px 0' }}>
                Holders registered by <i style={{ color: 'var(--primary-text-color)' }}>{state?.name}</i>
            </h2>

            {// @ts-ignore
                holders?.length !== 0 &&
                <section className="user-list">
                    <div className="list-header">
                        <span>Name</span>
                        <span>Mobile</span>
                        <span>Member count</span>
                        <span>Action</span>
                    </div>

                    <div className="list-body">
                        {// @ts-ignore
                            holders.map((holder) => (
                                <div className="list-row" key={holder?._id}>
                                    <span className='truncate' title={holder?.name} data-label="Name">{holder?.name}</span>
                                    <span className='truncate' title={holder?.mobile} data-label="Mobile">{holder?.mobile}</span>
                                    <span className='truncate' title={holder?.members?.length} data-label="Member count">{holder?.members?.length || 0}</span>
                                    <span><button className="close-btn" onClick={() => handleDelete(holder?._id)}>Delete</button>&nbsp;</span>
                                </div>
                            ))
                        }
                    </div>

                </section>
            }

            {totalHolders !== holders.length ?
                <div>
                    <button className='add-btn' disabled={pageLoading} onClick={fetchUnpaidHolders}>{pageLoading ? <span className='spinner' /> : 'Load more'}</button>
                </div>
                : <></>
            }
        </div>
    )
}

export default AdminUnpaidHolders;
